




export default {
  name: 'PdfIcon'
}
